import { render, staticRenderFns } from "./flavour-types.vue?vue&type=template&id=6cd75216&"
import script from "./flavour-types.vue?vue&type=script&lang=js&"
export * from "./flavour-types.vue?vue&type=script&lang=js&"
import style0 from "./flavour-types.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports